import { useNavigate } from 'react-router'
import { Button } from '../common/html/button'
import saveLayout from '../helpers/SaveLayout'
import { sessionStorageKeys } from '../utils/common'
import classes from './ErrorCommon.module.scss'

export const BackToPreviousPage = () => {
  const navigate = useNavigate()

  const action = () => {
    navigate(saveLayout.get(sessionStorageKeys.KEY_ROUTE))
  }

  return (
    <Button
      isI18n
      className={classes.previousBtn}
      label={'error.BACK_TO_PREVIOUS_PAGE'}
      style={{ backgroundColor: '#2C73E8', color: '#FFFFFF' }}
      action={action}
    />
  )
}
